export const GET_GENDERS = "GET_GENDERS"
export const GET_QUALIFICATIONS = "GET_QUALIFICATIONS"
export const GET_SKILLS = "GET_SKILLS"
export const GET_REGIONS = "GET_REGIONS"



// WEBPACK FOOTER //
// ./src/actionTypes/lookupCode.js